import { render, staticRenderFns } from "./iconChecked.vue?vue&type=template&id=5f12c2e4&scoped=true&lang=pug"
import script from "./iconChecked.vue?vue&type=script&lang=js"
export * from "./iconChecked.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f12c2e4",
  null
  
)

export default component.exports